import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../Layout/Loader';
import { Navigate } from 'react-router-dom';
import { Alert } from 'reactstrap';
import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';
import setAuthCredentials from '../../setAuthCredentials';
import { withTranslator } from '../../../I18n/withTranslator';
import RegisterViaFacebookConnectorApollo from './Connector/Apollo/RegisterViaFacebookConnectorApollo';
import AuthRegisterByFacebookTokenWrapperComponent from './AuthRegisterByFacebookTokenWrapperComponent';
import withAppContext from '../../../AppContext/withAppContext';

class AuthRegisterByFacebookTokenComponent extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errors: [],
    };
  }

  registerViaFacebook = async (registerViaFacebook, userDataOnDemand) => {
    const response = await registerViaFacebook;

    if (response.data.auth.registerViaFacebook.__typename === 'OauthException') {
      if (response.data.auth.registerViaFacebook.code === 400) {
        this.setState((prevState) => ({
          errors: [...prevState.errors, this.props.t('auth/login/user-exists')],
        }));
      }
    } else {
      const userToken = response.data.auth.registerViaFacebook.token;
      setAuthCredentials(userToken);
      await userDataOnDemand();
    }

    this.setState({ isLoading: false });
  };

  render() {
    const token = new URL(document.location.href).searchParams.get('code');
    const state = new URL(document.location.href).searchParams.get('state');
    let returnPath = '/cart';

    if (state === 'stripe') {
      returnPath = '/buy';
    } else if (state === 'auth_register') {
      returnPath = '/';
    } else if (state === 'cart_register') {
      returnPath = '/cart/save-payment';
    } else if (state === 'activate_product_register') {
      returnPath = '/coupon/access-code';
    }

    return (
      <React.Fragment>
        {this.state.errors.map((msg) => (
          <Alert color="danger" key={msg}>
            {msg}
          </Alert>
        ))}
        <RegisterViaFacebookConnectorApollo>
          {(result) => (
            <UserDataOnDemand>
              {(result2) => (
                <AuthRegisterByFacebookTokenWrapperComponent
                  registerViaFacebook={() =>
                    this.registerViaFacebook(
                      result.registerViaFacebook(token),
                      result2.userDataOnDemand
                    )
                  }
                />
              )}
            </UserDataOnDemand>
          )}
        </RegisterViaFacebookConnectorApollo>
        {this.state.isLoading ? (
          <div className="full-height">
            <Loader />
          </div>
        ) : null}

        {!this.state.isLoading && !this.state.errors.length ? <Navigate to={returnPath} /> : null}
      </React.Fragment>
    );
  }
}

export default withAppContext(withTranslator(AuthRegisterByFacebookTokenComponent));
